import { SupplyWalkSingleContainer } from "./container";
import { PageFrame } from "../../components/page_frame";

export const SupplyWalkSinglePage = () => {
  return (
    <PageFrame>
      <SupplyWalkSingleContainer />
    </PageFrame>
  );
};
